/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RemoveAssetDto { 
    /**
     * Asset ids to delete
     */
    assetIds: Array<string>;
    projectId?: string;
    subProjectId?: string;
    taskId?: string;
    teamId?: string;
}

